module.exports = __webpack_public_path__ + "img/img.34605805.png";